import Immutable from 'immutable';
import getMomentAtLocation from 'app/helpers/locations/getMomentAtLocation';

// eslint-disable-next-line consistent-return
export function isOpen(location, hours, localNow) {
  if (hours.get('openTime') && hours.get('closeTime')) {
    const localOpenTime = getMomentAtLocation(location, hours.get('openTime'), localNow);
    const localCloseTime = getMomentAtLocation(location, hours.get('closeTime'), localNow);
    return localOpenTime?.isSameOrBefore(localNow, 'minute') && localCloseTime?.isAfter(localNow, 'minute');
  }
  if (hours.get('openTime') && !hours.get('closeTime')) {
    const localOpenTime = getMomentAtLocation(location, hours.get('openTime'), localNow);
    return localNow.isSameOrAfter(localOpenTime, 'minute');
  }
  if (!hours.get('openTime') && hours.get('closeTime')) {
    const localCloseTime = getMomentAtLocation(location, hours.get('closeTime'), localNow);
    return localNow.isBefore(localCloseTime, 'minute');
  }
}

export default function getActiveHours(location, specialHours) {
  const localNow = getMomentAtLocation(location);
  if (!localNow) return null;

  const activeSpecialHours = specialHours.find(hours => {
    let localStartDate = getMomentAtLocation(location, hours.get('startDate'));
    const localEndDate = getMomentAtLocation(location, hours.get('endDate'));
    let isSpecialHourActive =
      localStartDate.isSameOrBefore(localNow, 'date') && localEndDate.isSameOrAfter(localNow, 'date');
    if (hours.get('openTime') && !hours.get('closeTime')) {
      localStartDate = getMomentAtLocation(location, `${hours.get('startDate')}${hours.get('openTime')}`);
      // should return true only if special hours is active for today
      isSpecialHourActive =
        localStartDate.isSame(localNow, 'date') &&
        localStartDate.isSameOrAfter(localNow) &&
        localEndDate.isSameOrAfter(localNow, 'date');
    }
    return isSpecialHourActive;
  });

  if (activeSpecialHours) {
    return isOpen(location, activeSpecialHours, localNow)
      ? activeSpecialHours
      : Immutable.Map({ name: activeSpecialHours.get('name') });
  }

  // Regular hours
  const todayHours = location.get('sortedHours').find(sorted => sorted.get('isToday'));
  return todayHours?.get('hours')?.find(hours => isOpen(location, hours, localNow));
}
